import type { TrialPhase } from './types';

export const TRIAL_BADGE_COLORS: Record<Exclude<TrialPhase, 'hard_stop'>, string> = {
  active_safe: '#fce5a5',
  active_warning: '#f8d2b5',
  active_critical: '#ebb8bb',
  grace_period: '#ebb8bb',
};

export const FROZEN_PATTERN = `repeating-linear-gradient(
  -45deg,
  #ebb8bb,
  #ebb8bb 2px,
  #f8d9da 2px,
  #f8d9da 4px
)`;
